module.exports = __webpack_public_path__ + "img/ZAsymbol.f702b113.svg";